import intl from 'react-intl-universal';
import { useRef, forwardRef, useImperativeHandle } from 'react';
import { history, useLocation } from '@umijs/max';
import { CloseCircleOutlined } from '@ant-design/icons';
import styles from './index.less';
import classNames from 'classnames';
import { Dropdown, MenuProps } from 'antd';

const Tab: React.FC<{
    node: TabType;
    closeable?: boolean;
    closeTab: () => void;
    closeOtherTab: () => void;
    closeAllTab: () => void;
}> = forwardRef(
    ({ node, closeable = true, closeTab, closeOtherTab, closeAllTab }, ref) => {
        const location = useLocation();
        const domRef = useRef();

        useImperativeHandle(ref, () => {
            return {
                target: domRef.current,
                node,
            };
        });

        // 点击切换标签页
        const clickTab = () => {
            if (location.pathname !== node.path) {
                history.push(node.path + (node.search ? node.search : ''));
            }
        };
        // 关闭标签页
        const closeTabAction = (e: any) => {
            e.stopPropagation();
            closeTab();
        };

        const items: MenuProps['items'] = [
            {
                key: '1',
                label: (
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href=""
                        onClick={(e) => {
                            e.preventDefault();
                            closeTab();
                        }}
                    >
                        {intl.get('关闭')}
                    </a>
                ),
            },
            {
                key: '2',
                label: (
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href=""
                        onClick={(e) => {
                            e.preventDefault();
                            closeOtherTab();
                        }}
                    >
                        {intl.get('关闭其它')}
                    </a>
                ),
            },
            {
                key: '3',
                label: (
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href=""
                        onClick={(e) => {
                            e.preventDefault();
                            closeAllTab();
                        }}
                    >
                        {intl.get('关闭所有')}
                    </a>
                ),
            },
        ];

        return (
            <Dropdown
                className="tabDropdown"
                menu={{ items }}
                placement="bottom"
                arrow
                trigger={['contextMenu']}
                destroyPopupOnHide={true}
            >
                <div
                    ref={domRef}
                    className={classNames(styles.tab, {
                        [styles.active]: location.pathname === node.path,
                    })}
                    onClick={clickTab}
                >
                    <span
                        data-cy={'tab-' + node.title}
                        className={styles.title}
                    >
                        {node.title}
                    </span>

                    {closeable && (
                        <CloseCircleOutlined
                            className={styles.closeBtn}
                            onClick={closeTabAction}
                        />
                    )}
                </div>
            </Dropdown>
        );
    },
);

export default Tab;
